import { api } from "./clientInstance";

export const getMe = () => {
  console.log("GET ME CALLED");
  return api("/user/me");
};

// Login, implementar y usar este para tener todo lo de api en esta carpeta
// ahora esta en login form
/*export const login = async (username, password) => {
  const res = await client.post("/auth/login", {
    Name: username,
    Password: password,
  });

  return res.data;
};*/